import { CandidateCommunicationQuery } from '../../../../__generated__/graphql';

export type CommunicationData =
  CandidateCommunicationQuery['candidateCommunication'];
export type Message = CommunicationData['messages'][number];
export type Sender = CommunicationData['senders'][number];

// Undated messages sort as newest so they can still become the reply parent.
export const sortByDateAscending = (
  messages: ReadonlyArray<Message>,
): Message[] =>
  [...messages].sort((a, b) => {
    const aTime = a.messageDate
      ? new Date(a.messageDate).getTime()
      : Number.MAX_SAFE_INTEGER;
    const bTime = b.messageDate
      ? new Date(b.messageDate).getTime()
      : Number.MAX_SAFE_INTEGER;
    return aTime - bTime;
  });

export const toReplySubject = (lastMessage: Message | null): string => {
  if (!lastMessage?.subject) {
    return '';
  }
  return /^re:/i.test(lastMessage.subject)
    ? lastMessage.subject
    : 'Re: ' + lastMessage.subject;
};

export const formatSender = (sender: Sender): string =>
  sender.displayName
    ? sender.displayName + ' <' + sender.address + '>'
    : sender.address;

export const toHtmlBody = (body: string): string =>
  body
    .split('\n')
    .map((line) => '<p>' + escapeHtml(line) + '</p>')
    .join('');

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
